import React from "react";
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { pathOr } from "ramda";
import { Divider } from "@mui/material";
import '../index.css'
import { BarChart } from '@mui/x-charts/BarChart';


const Graph = (props) => {
    const { policy } = props
    const status = pathOr('', ['policyStatus'], policy)
    const savingType=pathOr('',['savingType'],policy)
    const graphData = () => {
      const data = policy.oneView.returns.map((d,i) => {
        return({
          percentage: `${d.rateOfReturn}%`,
          amount: d.maturityValue 
        })
      })
      return data
    }

const translations = {
  amount: 'Appro Maturity Amount',

};

function addLabels(series) {
  return series.map((item) => ({
    ...item,
    label: translations[item.dataKey],
    valueFormatter: (v) => (v ? `₹ ${v.toLocaleString()}` : '-'),
  }));
}
    

    return (

        <div style={{marginTop:'24px',border:'1px solid #D9D9D9',borderRadius:18}}>
            <Typography ml={1} mt={1}>{"If paid regularly.."}</Typography>
          <BarChart margin={{ left: 100 }}
      dataset={graphData()}
      series={addLabels([
        { dataKey: 'amount', stack: 'amount' },
      ])}
      xAxis={[{ scaleType: 'band', dataKey: 'percentage' }]}
      slotProps={{ legend: { hidden: true } }}
      width={500}
      height={350}
            />
            </div>
    );
       
}

export default Graph